import * as _ from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';

import Dialog from 'kpc/components/dialog';
import { Table, TableColumn } from 'kpc/components/table';
import Icon from 'kpc/components/icon';
import { Form, FormItem } from 'kpc/components/form';
import { Button, ButtonGroup } from 'kpc/components/button';
import Input from 'kpc/components/input';
import Spin from 'kpc/components/spin';
import { Tabs, Tab } from 'kpc/components/tabs';
import Tooltip from 'kpc/components/tooltip';
import Message from 'kpc/components/message';
import Tip from 'kpc/components/tip';
import Upload from 'kpc/components/upload';
import * as xlsxService from '../../../service/common/xlsx'
import whiteList from "../../../service/common/whiteList";
import getDhcp from "../../validator/getDhcp";
import rulesCheck from "../../validator/sgRulesCheck";
import * as ipAddr from 'ip-address'

import vpcData from "../../../service/vpc/vpcData";
import TableWithPagination from "../../../components/TableWithPagination/index.vue";
import getChargeTypeChina from '../../../service/common/getChargeTypeChina';
import apiRequest from '../../../service/vpc/request';

@Component({
    components: {
        Dialog,
        Table,
        TableColumn,
        Icon,
        Tip,
        Form,
        FormItem,
        Button,
        ButtonGroup,
        Input,
        Upload,
        TableWithPagination,
        Spin,
        Tabs,
        Tab,
        Tooltip
    }
})
export default class ImportRuleDialog extends Vue {
    cb?: () => void;
    region = "";
    interfaceEpcCount: number = 0;
    sgSupportEpcDeny: boolean = false;
    currVpcSupportIpv6: boolean = true;
    type = "";
    importRule: any = {
        show: false
    };
    icmpTypeToString = {
        "-1": this.$trans("all_protocal"),
        8: "Echo",
        0: "Echo Reply",
        3: "Destination Unreachable",
        4: "Source Quench",
        5: "Redirect Message",
        9: "Router Advertisement",
        10: "Router Solicitation",
        11: "Time Exceeded",
        12: "Parameter Problem: Bad IP header",
        13: "Timestamp",
        14: "Timestamp Reply",
        15: "Information Request",
        16: "Information Reply",
        17: "Address Mask Reques",
        18: "Address Mask Reply",
        30: "Traceroute"
    };
    importRuleTitle = "";
    numberAll: number = 0;
    numberNoCheck: number = 0;
    importListNew: any[] = [];
    maxSize: number = 500;
    allRepeatedRules: any[] = [];
    originRules: any = {};
    SheetNames: any[] = [];
    Sheets: any = {};
    expandedKeys: any[] = [];
    rulesClone: any[] = [];
    checkedRepeatedRules: any[] = [];
    originArrParam: any[] = [];
    groupId = "";
    isOutRuleIP0: boolean = false;
    onOffNum = 0;
    vpcData: any = vpcData;
    getChargeTypeChina = getChargeTypeChina;
    disabledImportRuleBtn: boolean = true;
    deletedRuleIdIn: any[] = [];
    uploadFile: any[] = [];

    get regionSupportDeny() {
        let me: any = this;
        return whiteList.check("sgSupportDeny", me.region);
    }

    get supportSgTag() {
        const me: any = this;
        return whiteList.check("sgTag", me.region);
    }

    @Watch("importListNew", {
        deep: true
    })
    ImportListNewWatcher(val: any) {
        let me: any = this;
        if (val.length) {
            me.disabledImportRuleBtn = false;
        } else {
            me.disabledImportRuleBtn = true;
        }
        me.allRepeatedRules = _.filter(val, item => {
            return item.isRepeatRule;
        }) || [];
        me.numberAll = val.length;
    }

    onClose() {
        let me: any = this;
        me.isOutRuleIP0 = false;
        me.onOffNum = 0;
        me.numberAll = 0;
        me.numberNoCheck = 0;
        me.allRepeatedRules = [];
        me.importListNew = [];
        me.uploadFile = [];
    }

    _onError(err: any) {
        Message.error(err.message);
    }

    _beforeRemove(file: any) {
        let me: any = this;
        me.uploadFile = [];
        me.importList = [];
        me.importListNew = [];
        me.numberAll = 0;
        me.numberNoCheck = 0;
        me.allRepeatedRules = [];
    }

    exportRules(type: any) {
        this.$parent.exportRules(type);
    }

    fixdata(data: any) {
        var o = "",
            l = 0,
            w = 10240;
        for (; l < data.byteLength / w; ++l) {
            o += String.fromCharCode.apply(
                null,
                new Uint8Array(data.slice(l * w, l * w + w)) as any
            );
        }
        o += String.fromCharCode.apply(
            null,
            new Uint8Array(data.slice(l * w)) as any
        );
        return o;
    }

    //读取导入的列表内容
    async handleFiles(e: any) {
        let me: any = this;
        let files = e.target.files;

        me.uploadFile = [
            {
                status: "done",
                name: files[0].name,
                percent: 100,
                uid: 0,
                raw: files[0],
                url: files[0].url
            }
        ];

        let { xlsx } = await xlsxService.getXlsxAndFileSaver();
        for (let i = 0; i != files.length; ++i) {
            let f = files[i];
            let reader = new FileReader();
            // let name = f.name;
            reader.onload = e => {
                let data: any = _.get(e, "target.result");
                let rABS = false;
                let workbook;
                if (rABS) {
                    /* if binary string, read with type 'binary' */
                    workbook = xlsx.read(data, { type: "binary" });
                } else {
                    /* if array buffer, convert to base64 */
                    let arr = me.fixdata(data);
                    workbook = xlsx.read(btoa(arr), { type: "base64" });
                }
                // console.log(JSON.stringify(workbook.Sheets.records),'workbook')
                me.getImportList(workbook.Sheets.records);

                /* DO SOMETHING WITH workbook HERE */
            };
            reader.readAsArrayBuffer(f);
        }
    }

    getImportList(data: any) {
        var me: any = this;
        if (!data) {
            return;
        }

        //兼容旧版列表数据导入，格式化数据结构
        if (data.B1.v == me.$trans(`行为`) && me.regionSupportDeny) {
            Message.error("规则已经更新，不能导入旧版规则！");
            return;
        }

        if (data.B1.v == me.$trans(`优先级`) && !me.regionSupportDeny) {
            Message.error("规则格式不匹配！");
            return;
        }


        me.importList = [];
        me.importListNew = [];
        me.numberNoCheck = 0;
        me.numberAll = 0;
        me.numberNoCheck = 0;

        let str = [
            me.$trans(`协议`),
            me.$trans(`行为`),
            me.$trans(`起始端口`),
            me.$trans(`结束端口`),
            me.type == "inRule" ? me.$trans(`源IP`) : me.$trans(`目标IP`),
            "TAG",
            me.$trans(`备注`)
        ].join(",");

        var thead: any[] = [];
        var arrHead = [];
        thead.push(data.A1.v);
        thead.push(data.B1.v);
        thead.push(data.C1.v);
        thead.push(data.D1.v);
        thead.push(data.E1.v);
        
        if (!me.regionSupportDeny) {
            str = [
                me.$trans(`协议`),
                me.$trans(`行为`),
                me.$trans(`起始端口`),
                me.$trans(`结束端口`),
                me.type == "inRule" ? me.$trans(`源IP`) : me.$trans(`目标IP`),
                "TAG",
                me.$trans(`备注`)
            ].join(",");
            if(data.F1.v == me.$trans('创建时间')) {
                thead.push(data.G1.v);
                thead.push(data.H1.v);
                arrHead = ["A", "B", "C", "D", "E", "G", "H"];
            } else {
                thead.push(data.F1.v);
                thead.push(data.G1.v);
                arrHead = ["A", "B", "C", "D", "E", "F", "G"];
            }
        } else {
            str = [
                me.$trans(`优先级`),
                me.$trans(`访问权限`),
                me.$trans(`协议`),
                me.$trans(`起始端口`),
                me.$trans(`结束端口`),
                me.type == "inRule" ? me.$trans(`源IP`) : me.$trans(`目标IP`),
                "TAG",
                me.$trans(`备注`)
            ].join(",");

            if(data.G1.v == me.$trans('创建时间')) {
                thead.push(data.F1.v);
                thead.push(data.H1.v);
                thead.push(data.I1.v);
                arrHead = ["A", "B", "C", "D", "E", "F", "H", "I"];
            } else {
                thead.push(data.F1.v);
                thead.push(data.G1.v);
                thead.push(data.H1.v);
                arrHead = ["A", "B", "C", "D", "E", "F", "G", "H"];
            }
        }

        var theadOff = false; //只要有一个thead不对 就是true
        for (var i = 0; i < thead.length; i++) {
            if (str.indexOf(thead[i]) == -1) {
                theadOff = true;
            }
        }
        if (theadOff) {
            //me.bodyShow=false;
            me.numberAll = 0;
            me.numberNoCheck = 0;
            return;
        }
        //以下获取内容数据
        var jsonA2start = _.cloneDeep(data);
        var arrNumber: any[] = [];
        var arrNumberNew: any[] = [];
        var max = 0;

        for (let i in jsonA2start) {
            arrNumber.push(i.match(/\d+/g));
        }
        _.forEach(arrNumber, v => {
            if (v != null) {
                arrNumberNew.push(v.join(","));
            }
        });
        max = Math.max.apply(null, arrNumberNew);
        // var arrHead = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
        for (var i = 2; i <= max; i++) {
            var arrList = [];
            for (var j = 0; j < arrHead.length; j++) {
                if (jsonA2start[arrHead[j] + i]) {
                    arrList.push(jsonA2start[arrHead[j] + i].w);
                } else {
                    arrList.push("");
                }
            }
            me.importList.push(arrList);
        }

        var arr: any[] = [];
        var importListClone = _.cloneDeep(me.importList);

        _.forEach(importListClone, (item, index) => {
            var arri: any[] = item.map((ele:any) => {
                return ele.trim();
            });
            me.icmpCodeText = "";
            if (me.regionSupportDeny) {
                if (arri[2] == "ip") {
                    arr.push({
                        Priority: arri[0],
                        Policy: arri[1],
                        Protocol: arri[2],
                        PortRangeFrom: arri[3],
                        PortRangeTo: arri[4],
                        CidrBlock: arri[5],
                        RuleTag: arri[6],
                        Description: arri[7]
                    });
                }
                if (arri[2] == "icmp") {
                    arr.push({
                        Priority: arri[0],
                        Policy: arri[1],
                        Protocol: arri[2],
                        IcmpType: arri[3],
                        IcmpCode: _.toNumber(arri[4]),
                        CidrBlock: arri[5],
                        RuleTag: arri[6],
                        Description: arri[7]
                    });
                }
                if (arri[2] == "tcp" || arri[2] == "udp") {
                    arr.push({
                        Priority: arri[0],
                        Policy: arri[1],
                        Protocol: arri[2],
                        PortRangeFrom: arri[3],
                        PortRangeTo: arri[4],
                        CidrBlock: arri[5],
                        RuleTag: arri[6],
                        Description: arri[7]
                    });
                }
            } else {
                if (arri[0] == "ip") {
                    arr.push({
                        Protocol: arri[0],
                        PortRangeFrom: arri[2],
                        PortRangeTo: arri[3],
                        CidrBlock: arri[4],
                        RuleTag: arri[5],
                        Description: arri[6]
                    });
                }
                if (arri[0] == "icmp") {
                    arr.push({
                        Protocol: arri[0],
                        IcmpType: arri[2],
                        IcmpCode: _.toNumber(arri[3]),
                        CidrBlock: arri[4],
                        RuleTag: arri[5],
                        Description: arri[6]
                    });
                }
                if (arri[0] == "tcp" || arri[0] == "udp") {
                    arr.push({
                        Protocol: arri[0],
                        PortRangeFrom: arri[2],
                        PortRangeTo: arri[3],
                        CidrBlock: arri[4],
                        RuleTag: arri[5],
                        Description: arri[6]
                    });
                }
            }
        });


        let formatArr = rulesCheck.sgRulesCheck(arr, me, getDhcp);

        let expandedKeys: any[] = [];
        _.forEach(formatArr, (item, index) => {
            if (item.isError) {
                expandedKeys.push(index);
            }
        });
        me.expandedKeys = expandedKeys;

        //最后展示的数据 带有check检验的
        me.importListNew = formatArr;
        //根据check判断 按钮状态 和文字 numberNoCheck==0 全部导入通过
        var i = 0;
        _.forEach(me.importListNew, item => {
            if (item.IcmpType == null || item.IcmpType == "-1") {
                item.IcmpType = "-1";
                item.IcmpCode = 0;
            }
            if (item.isError) {
                i++;
            }
        });
        me.numberNoCheck = i;
    }

    oneKeyDistinct() {
        const me: any = this;
        let idx: any[] = [];
        _.forEach(me.allRepeatedRules, (item, index) => {
            if (item.isRepeatRule) {
                idx.push(index);
            }
        });
        let filterData = _.filter(me.importListNew, (item, index) => {
            return !_.includes(idx, index);
        });
        me.importListNew = filterData;
    }

    deleteRule(row:any, index: any) {
        const me = this;
        me.importListNew.splice(index, 1);
    }

    comparator(deny: any, value: any, other: any) {
        let icmpType = null;
        let icmpCode = null;
        let portRangeFrom = null;
        let portRangeTo = null;

        if (other.Protocol == "tcp" || other.Protocol == "udp") {
            portRangeFrom = other.PortRangeFrom;
            portRangeTo = other.PortRangeTo;
        }

        if (other.Protocol == "icmp") {
            icmpType = other.IcmpType;
            icmpCode = other.IcmpType == '-1' ? '-1' : other.IcmpCode;
        }

        let isValid = value.Protocol == other.Protocol &&
            Number(value.IcmpType) == Number(icmpType) &&
            Number(value.IcmpCode) == Number(icmpCode) &&
            Number(value.PortRangeFrom) == Number(portRangeFrom) &&
            Number(value.PortRangeTo) == Number(portRangeTo)

        if (deny == 'supportDeny') {
            isValid = value.Policy == other.Policy && isValid
        }
        let isSameIp = false;
        if (value.CidrBlock && other.CidrBlock) {
            let origionIps = value.CidrBlock.split(",");
            let importIps = other.CidrBlock.split(",");
            _.forEach(origionIps, oIp => {
                _.forEach(importIps, iIp => {
                    if (oIp === iIp) {
                        isSameIp = true;
                    }
                });
            });
        }

        return isValid && isSameIp;
    }

    ok() {
        let me: any = this;
        let dialog: any = me.$refs.dialog;
        me.allRepeatedRules = [];
        let isRepeatedRule: any[] = [];
        let noRepeatedRule: any[] = [];

        // 判断导入规则是否已经存在
        _.forEach(me.originRules, (item) => {
            _.forEach(me.importListNew, (subitem, subindex) => {
                if(me.regionSupportDeny) {
                    if (me.comparator('supportDeny', item, subitem)) {
                        subitem.isError = true;
                        subitem.isRepeatRule = true;
                        isRepeatedRule.push(subitem);
                    }
                } else {
                    if (me.comparator("notSupportDeny", item, subitem)) {
                        subitem.isError = true;
                        subitem.isRepeatRule = true;
                        isRepeatedRule.push(subitem);
                    }
                }
            });
        });
        noRepeatedRule = _.filter(me.importListNew, (item) => { return !item.isRepeatRule });
        me.importListNew = isRepeatedRule.concat(noRepeatedRule);
        me.allRepeatedRules = isRepeatedRule;

        if (me.numberNoCheck || me.allRepeatedRules.length) {
            Message.error(me.$trans(`有规则错误，请修正规则后再提交！`));
            return;
        }

        let list = _.filter(me.importListNew, item => !item.isError) || [];
        me.cb && me.cb(list);

        // 重置变量，如果用户一键去重之后还希望继续添加，则还能够操作
        me.allRepeatedRules = [];
        me.importRule.show = false;
        me.importListNew = [];
        me.numberAll = 0;
        me.numberNoCheck = 0;
        dialog.hideLoading();
        // me.cb && me.cb();
    }

    public open(
        region: string,
        currVpcSupportIpv6: boolean,
        interfaceEpcCount: number,
        sgSupportEpcDeny: boolean,
        type: any[],
        rules: any[],
        cb: any
    ) {
        let me: any = this;
        me.region = region;
        me.currVpcSupportIpv6 = currVpcSupportIpv6;
        me.interfaceEpcCount = interfaceEpcCount;
        me.sgSupportEpcDeny = sgSupportEpcDeny;
        me.cb = cb;
        me.type = type;
        me.originRules = rules;
        me.importRule.show = true;
        me.groupId = me.$route.params.groupId;
        me.importRuleTitle =
            me.type == "inRule"
                ? me.$trans(`批量导入-入站规则`)
                : me.$trans(`批量导入-出站规则`);
    }
};

